import { render } from "./AutomatonsView.vue?vue&type=template&id=959eacf4&scoped=true"
import script from "./AutomatonsView.vue?vue&type=script&lang=js"
export * from "./AutomatonsView.vue?vue&type=script&lang=js"

import "./AutomatonsView.vue?vue&type=style&index=0&id=959eacf4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-959eacf4"]])

export default __exports__